/* eslint-disable linebreak-style */
/* eslint max-len: ["error", { "code": 500 }] */
import React from 'react';
import './QuoteScreen.css';

const QuoteScreen = () => (
  <div className="quotescreen-container">
    <p>Mathematics is not about numbers, equations, computations, or algorithims: it is about understanding, - William Paul Thurston</p>
  </div>
);

export default QuoteScreen;
